import { render, staticRenderFns } from "./saleslevparttrac.vue?vue&type=template&id=547fecb2&scoped=true&"
import script from "./saleslevparttrac.vue?vue&type=script&lang=js&"
export * from "./saleslevparttrac.vue?vue&type=script&lang=js&"
import style0 from "./saleslevparttrac.vue?vue&type=style&index=0&id=547fecb2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547fecb2",
  null
  
)

export default component.exports